<template>
    <div class="m-shop-view">
        <div class="shop-item"><welfare/></div>
        <div class="shop-item"><rebate/></div>
        <div class="shop-item"><expack/></div>
        <div class="shop-item"><vippack/></div>
    </div>
</template>

<script>
import welfare from '@/components/Shop/welfare'
import rebate from '@/components/Shop/rebate'
import expack from '@/components/Shop/expack'
import vippack from '@/components/Shop/vippack'

export default {
  components: {
    welfare,
    rebate,
    expack,
    vippack,
  },    
}
</script>

<style scoped>
.shop-item{
    margin-bottom: 86px;
    padding: 0 16px;
}
</style>


// WEBPACK FOOTER //
// src/components/shop.vue